var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee font-size-large font-weight-bold line-height-1"},[_c('div',{attrs:{"id":"div1"}},[_vm._v(" "+_vm._s(_vm.$t('home.marquee'))+" ")]),_c('div',{attrs:{"id":"div2"}},[_vm._v(" "+_vm._s(_vm.$t('home.marquee'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }